<script lang="ts" setup>
import type {IAddress} from '@/types/address';
import {computed} from 'vue';
import {useQuizStore} from "@/stores/quizStore.ts";

const props = defineProps<{ addresses: IAddress[], maxAddresses: number }>()

const {selectedVehicles} = useQuizStore()


const footer = computed(() => {
  const footerDescription = [
    {
      title: 'Let\'s link your vehicle to your address.',
      content: `
        <strong>Begin with where you live now.</strong><br>
        Past addresses will help discover your hidden commission finance claims.<br>
        Simply enter your postcode to start the search!
      `,
      label: 'Current Address'
    },
    {
      title: 'Current address added, nice one!',
      content: `
        <strong>Lived anywhere else?</strong> More addresses could mean more hidden claims <strong>and more money!</strong>
      `,
      label: 'If this is your only address, just hit continue.'
    },
    {
      title: 'Got one more in the tank?',
      content: `
        Adding another could boost your chances even more<br><br>
        If not, no problem! Two addresses is <strong class="italic">just fine</strong>.
      `,
      label: ''
    }
  ]
  const footerDescriptionWithoutVehicles = [
    {
      title: 'Addresses hold clues — see if a hidden claim is linked to yours.',
      content: `
        <strong>Begin with where you live now.</strong><br>
        Start with your current postcode, it's the first step to uncovering hidden claims
      `,
      label: 'Current Address'
    },
    {
      title: 'Current address added, nice one!',
      content: `
        <strong>Lived anywhere else?</strong> More addresses could mean more hidden claims <strong>and more money!</strong>
      `,
      label: 'If this is your only address, just hit continue.'
    },
    {
      title: 'Got one more in the tank?',
      content: `
        Adding another could boost your chances even more<br><br>
        If not, no problem! Two addresses is a strong start. <strong>Just hit Continue when you're ready.</strong>
      `,
      label: ''
    }
  ]

  if (!selectedVehicles.length) {
    return footerDescriptionWithoutVehicles[props.addresses.length] ?? footerDescriptionWithoutVehicles[2]
  }

  return footerDescription?.[props.addresses.length] ?? footerDescription[2]
})

const showText = computed(() => props.addresses.length < props.maxAddresses)
</script>

<template>
  <div v-if="showText">
    <h4 class="text-xl font-medium mb-2">{{ footer.title }}</h4>
    <p class="text-base mb-4" v-html="footer.content"/>
    <p v-if="footer.label" class="mb-2">{{ footer.label }}</p>
  </div>
</template>
